import * as ko from 'knockout'
import ObservableResultsPage from '@classic/Betting-v2/Model/Observables/ObservableResultsPage'
import template from './results.tpl.html'
import { ResultsPageViewModel } from './ResultsPageViewModel'

if (!ko.components.isRegistered('race-results')) {
  ko.components.register('race-results', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsPageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
